import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-095c6a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "入力内容の確認")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text" }, [
  /*#__PURE__*/_createTextVNode(" この内容でよろしければ "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 「この内容で決定する」を押してください ")
], -1))
const _hoisted_4 = { class: "profile_item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "OS", -1))
const _hoisted_6 = { class: "profile_item_value" }
const _hoisted_7 = { class: "profile_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "profile_item_title" }, "ソフト", -1))
const _hoisted_9 = { class: "profile_item_value" }
const _hoisted_10 = { class: "profile_button_register" }
const _hoisted_11 = { class: "profile_button_modify" }

import { ref, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import alertOnReload from '@/utils/alertOnReload';

export default /*#__PURE__*/_defineComponent({
  __name: 'SkillSoftwareConfirmView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const usableSoftwareList: { label: string; value: boolean; key: string }[] = store.getters['careerSheetSkill/usableSoftwareList'];

const isLoading = ref(false);

const usableSoftwareOSList = computed(() => {
  return usableSoftwareList.slice(0, 3).filter((i) => i.value);
});
const usableSoftwareSoftList = computed(() => {
  return usableSoftwareList.slice(3).filter((i) => i.value);
});

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e57', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e57' });
  }
};

const save = async () => {
  isLoading.value = true;
  try {
    await store.dispatch('careerSheetSkill/saveUsableSoftwareList');
    store.dispatch('toasts/appendTimeToast', { label: 'PCソフトを更新しました' });
    if (route.query.ref === 'e') {
      router.push({ name: 'e50', query: { ref: 'e' } });
    } else {
      router.push({ name: 'n50' });
    }
  } catch (error) {
    store.dispatch('toasts/appendTimeToast', { label: 'PCソフトの更新に失敗しました', duration: null });
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usableSoftwareOSList), (usableSoftwareOS) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "profile_item_value_text",
            key: usableSoftwareOS.key
          }, _toDisplayString(usableSoftwareOS.label), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(usableSoftwareSoftList), (usableSoftwareSoft) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "profile_item_value_text",
            key: usableSoftwareSoft.key
          }, _toDisplayString(usableSoftwareSoft.label), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(BaseButton, {
        theme: "primary",
        onClick: save
      }, {
        default: _withCtx(() => [
          _createTextVNode("この内容で決定する")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(BaseButton, {
        theme: "secondary",
        onClick: transitionPreviousPage
      }, {
        default: _withCtx(() => [
          _createTextVNode("修正する")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})